// Vendor Libs
import React from 'react';

// Components
import Permissions from '../core/permissions';
import ProvidersForm from './providers-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createProvider';

const CreateProvider = () => (
    <Permissions
        accessRequirement="create"
        elementService="provider"
        notAuthorizedMessage={true}
        requiresServiceAccess={true}
    >
        <FormData formName={formName}>
            {({resetForm}) => (
                <ProvidersForm
                    {...{
                        className: 'create-provider',
                        formName,
                        editing: false,
                        onReset: resetForm,
                    }}
                />
            )}
        </FormData>
    </Permissions>
);

export default CreateProvider;
